import headerBar from './HeaderBar.vue'
const HeaderBar = {
	install: function(Vue) {
		Vue.component('HeaderBar', headerBar)
	}
}
export default HeaderBar
